/* Opens the CommSlayer chat bubble
to open chat bubble use either:
<a href="#" class="js-open-chat">Chat</a> 
<a href="#open-chat">Chat</a>
*/


(function () {
  const OPEN_HASH = '#open-chat';

  function getBubbleButton() {
    return (
      document.querySelector('.woot--bubble-holder .woot-widget-bubble[title="Open chat window"]') ||
      document.querySelector('.woot--bubble-holder .woot-widget-bubble')
    );
  }

  function isOpenChatTrigger(el) {
    if (!el) return false;

    // Class-based triggers still supported
    if (el.closest('.js-open-chat')) return true;

    // Link-only triggers (Customizer "Button" blocks usually render <a>)
    const link = el.closest('a[href], area[href]');
    if (link) {
      try {
        const url = new URL(link.getAttribute('href'), window.location.href);
        if (url.hash === OPEN_HASH) return true;
      } catch (e) {}
    }

    return false;
  }

  function clickBubbleWithRetry() {
    const bubble = getBubbleButton();
    if (bubble) {
      bubble.click();
      return;
    }

    let tries = 0;
    const t = setInterval(function () {
      const bubbleRetry = getBubbleButton();
      if (bubbleRetry) {
        clearInterval(t);
        bubbleRetry.click();
      } else if (++tries >= 20) {
        clearInterval(t);
      }
    }, 250);
  }

  document.addEventListener('click', function (e) {
    if (!isOpenChatTrigger(e.target)) return;

    e.preventDefault();
    clickBubbleWithRetry();
  }, false);

  // Optional: if someone lands on a URL ending in #open-chat, open chat on load
  if (window.location.hash === OPEN_HASH) {
    clickBubbleWithRetry();
  }
})();
